// microsoft graph scopes
export const GRAPH_USER_READ = 'User.Read';
export const GRAPH_PRESENCE_READ_ALL = 'Presence.Read.All';
export const GRAPH_OPENID_CONNECT_BASIC = ["openid", "profile", "offline_access"];

// microsoft graph scopes array
export const GRAPH_SCOPES = [
    GRAPH_USER_READ,
    GRAPH_PRESENCE_READ_ALL,
    ...GRAPH_OPENID_CONNECT_BASIC
];
